import httpUserClient from '@/plugins/httpUserClient';

export default {
  // 返回所有比赛
  getCompetesList(client, page, perPage) {
    return httpUserClient.get(`compete/activities?${client ? 'client=' : ''}${client}&page=${page}&per_page=${perPage}`);
  },
  // 返回历史比赛
  getHistoryCompetesList(page, perPage) {
    return httpUserClient.get(`/compete/activities/histories?page=${page}&per_page=${perPage}`);
  },
  // 查看某个比赛
  showCompete(competeId) {
    return httpUserClient.get(`compete/activities/${competeId}`);
  },
  // 用户鉴权查看某个比赛
  showUserCompete(competeId) {
    return httpUserClient.get(`user/compete/activities/${competeId}`);
  },
  // 获取用户报名参加的比赛列表
  getCompeteEntriesList() {
    return httpUserClient.get('user/compete/entries');
  },
  // 用户报名参加某一比赛
  createCompeteEntrie(data) {
    return httpUserClient.post('user/compete/entries', { compete_entry: { ...data } });
  },
  // 查看用户某一比赛的报名信息
  showEntrie(entrieId) {
    return httpUserClient.get(`user/compete/entries/${entrieId}`);
  },
  // 更新用户某一比赛的报名信息
  patchEntrie(data) {
    return httpUserClient.patch(`user/compete/entries/${data.id}`, { compete_entry: { ...data } });
  },
  // 用户取消某一比赛的报名
  deleteEntrie(entrieId) {
    return httpUserClient.delete(`user/compete/entries/${entrieId}`);
  },
  // 用户提交某比赛的作品
  postProduct(entrieId, data) {
    return httpUserClient.patch(`user/compete/entries/${entrieId}/product`, { compete_product: { product_meta: { ...data } } });
  },
  // 查看某一比赛可报名的项目列表
  getProjects(competeId) {
    return httpUserClient.get(`/compete/activities/${competeId}/projects`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/compete/competeApis.js